import React, { FC, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Svg from 'svg-inline-react';
import Checkbox from '@src/components/Checkbox';
import { setModalContent } from '@src/redux/actions/modal';
import { DEFAULT_CURRENCY_SYMBOL } from '@src/constants';
import { Label } from '@src/components/Label';
import { useAppDispatch } from '@src/redux';
import './styles.scss';

export const Addon: FC = ({ preview, addon, onClick, icons, title, contentText, isSelected }) => {
  const dispatch = useAppDispatch();

  const isBestSeller = addon.isBestSeller;
  const isIncluded = addon.isIncluded;

  return (
    <div
      className={classnames(
        'premium-service-item',
        isIncluded && 'premium-service-item--included',
        isSelected && 'premium-service-item--selected',
      )}
      onClick={() => onClick(addon)}
    >
      <div className="premium-service-item__checkbox-image-wrapper">
        <Checkbox disabled={isIncluded} propagateEvent value={isSelected} />
        <div
          className={classnames(
            'premium-service-item__image',
            icons.length > 1 && 'premium-service-item__image--multi',
          )}
        >
          {icons.map((icon, i) => (
            <Svg key={i} src={icon} />
          ))}
        </div>
      </div>

      <div className="premium-service-item__content">
        <div className="premium-service-item__content-title">
          {title}{' '}
          {isBestSeller && <Label text="Best seller" type="blue" wrapperClassName="premium-service-item__label" />}
        </div>
        <div className="premium-service-item__content-text">{contentText}</div>
        {!!preview && (
          <div
            className="premium-service-item__content-text premium-service-item__content-text--link"
            onClick={evt => {
              evt.stopPropagation();

              dispatch(
                setModalContent({
                  config: {
                    withoutPadding: true,
                  },
                  content: preview,
                }),
              );
            }}
          >
            Preview example
          </div>
        )}
      </div>

      {isIncluded ? (
        <div className="premium-service-item__price">
          <span>Included</span>
        </div>
      ) : (
        <div className="premium-service-item__price">
          {addon.discountedPriceInEur !== undefined && addon.discountedPriceInEur !== null ? (
            <Fragment>
              <span className="premium-service-item__old-price">
                {DEFAULT_CURRENCY_SYMBOL}
                {addon.priceInEur}
              </span>

              {addon.discountedPriceInEur > 0 ? (
                <span>
                  {DEFAULT_CURRENCY_SYMBOL}
                  {addon.discountedPriceInEur}
                  {addon.isRecurring ? '/mo' : ''}
                </span>
              ) : (
                <span>Free</span>
              )}
            </Fragment>
          ) : addon.priceInEur > 0 ? (
            <span>
              {DEFAULT_CURRENCY_SYMBOL}
              {addon.priceInEur}
              {addon.isRecurring ? '/mo' : ''}
            </span>
          ) : (
            addon.type !== 'PUBLIC_OPENING' && <span>Free</span>
          )}
        </div>
      )}
    </div>
  );
};

Addon.propTypes = {
  addon: PropTypes.object.isRequired,
  contentText: PropTypes.node.isRequired,
  icons: PropTypes.array.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  preview: PropTypes.node,
  title: PropTypes.node.isRequired,
};
